<template>
  <div>
    <h1 class="title">{{ $t('customer.widgetSettings.title', {crm: 'Zendesk'}) }}</h1>
    
    <ZendeskCreateEndUserDialog 
      v-if="dialogEntityShow && currentItem.type == 'end-user'"
      :dialogEntityShow="dialogEntityShow"
      :entityData="currentItem"
      :entityIndex="currentItemIndex"
      @entity-dialog-close="closeDialogEntity"
      @save-entity="saveEntity"
    /> 

    <ZendeskCreateTicketDialog 
      v-else-if="dialogEntityShow && currentItem.type == 'ticket'"
      :dialogEntityShow="dialogEntityShow"
      :entityData="currentItem"
      :entityIndex="currentItemIndex"
      @entity-dialog-close="closeDialogEntity"
      @save-entity="saveEntity"
    />

    <v-container fluid>
      <v-row left> 
        <v-col cols="2"></v-col>
        <v-col cols="8">
          <GoBack />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="1"></v-col>
        <v-col cols="8">
          <v-row left>
            <v-col
              v-for="(item, i) in items"
              :key="i"
              cols="12"
              xl="4"
              lg="4"
              md="6"
              sm="10"
              xs="12"
            >
              <v-tooltip
                v-if="item.type == 'end-user' || item.type == 'ticket'"
                :open-delay="tooltipDelay"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span>
                    <v-card
                      v-on="on"
                      height="95%"
                      class="d-flex flex-column pa-4 ma-2"
                      elevation="10"
                    >

                      <v-card-title class="pb-4 px-0 pt-0">
                        <v-container class="pa-0">
                          <v-row class="px-0">
                            <v-col cols="11" class="py-2"></v-col>
                            <v-col cols="1" class="py-2">
                              <v-tooltip
                                :open-delay="tooltipDelay"
                                class="px-0"
                                max-width="280"
                                top
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <span>
                                    <v-icon
                                      color="grey"
                                      class="mr-1 mt-1 tooltip-top-right"
                                      dark
                                      left
                                      v-bind="attrs"
                                      v-on="on"
                                    >mdi-information-outline</v-icon>
                                  </span>
                                </template>
                                <i18n path="customer.widgetSettings.entityTooltipInfo" tag="span">
                                  <template v-slot:itemType>
                                    {{ item.type | toCapitalCase }}
                                  </template>
                                </i18n>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                          
                          <v-row class="px-6 pt-2" align="center">
                            <v-col cols="10" class="pa-0 d-flex">
                              <span class="headline black--text">{{item.entityLabel}}</span>
                            </v-col>
                            <v-col cols="2" class="pa-0">
                              <v-tooltip
                                :open-delay="tooltipDelay"
                                bottom
                              >
                                <template v-slot:activator="{ on }">
                                  <span>
                                    <v-switch 
                                      v-model="item.disable" 
                                      v-on="on"
                                      class="pa-0 ma-0"
                                      :false-value="true" 
                                      :true-value="false" 
                                      hide-details
                                      @change="entityToggleChange(item,i)"
                                    ></v-switch>
                                  </span>
                                </template>
                                <i18n path="customer.widgetSettings.enableTooltip" tag="span">
                                  <template v-slot:action>
                                    {{ item.disable ? $t('enable') : $t('disable') }} 
                                  </template>
                                  <template v-slot:itemType>
                                    {{ item.type | toCapitalCase }}
                                  </template>
                                </i18n>
                              </v-tooltip>
                            </v-col>
                          </v-row>

                        </v-container>
                      </v-card-title>

                      <v-spacer></v-spacer>

                      <v-card-text
                        align="left"
                        v-text="item.type"
                      >
                      </v-card-text>

                      <!-- TODO change item.linkTranscript with toggle related field  (disable)-->
                      <v-card-actions class="d-flex justify-start">
                        <v-btn 
                          ref="entityButton" 
                          @click="openDialogEntity(item, i)"  
                          :disabled="item.disable"
                          v-bind="size" 
                          v-on="on"
                          class="px-2"
                          color="orange darken-1"
                          dark
                        >
                          <v-icon left>mdi-pencil</v-icon>{{ $t('customer.widgetSettings.fieldSettings') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </span>
                </template>
                <i18n path="customer.widgetSettings.entityTooltip" tag="span">
                  <template v-slot:itemType>
                    {{ item.type | toCapitalCase }}
                  </template>
                </i18n>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GoBack from "@/components/GoBack"
  import { customerMixin } from '../mixins/customerMixins'
  import resizeMixin from '../mixins/resizeMixins'
  import customerOps from '../api/users'
  import i18n from '../i18n';

  export default {
    props: {
      accountData: {
        required: true,
        type: Object
      }
    },
    mixins: [customerMixin, resizeMixin],
    components: {
      GoBack,
      ZendeskCreateEndUserDialog: () => import('@/components/ZendeskCreateEndUserDialog'),
      ZendeskCreateTicketDialog: () => import('@/components/ZendeskCreateTicketDialog')
    },
    created() {
      console.log(`[ZendeskWidgetConfig] - created...`);
      // set the accountObject with the props data
      this.accountObject = { ...this.accountData }
      this.items = { ...this.accountData.wconfig.entities };

      // get Customer Profile data 
      const customerProfile = this.$store.getters['users/getCustomerProfile'];

      // populate the customerProfile with the values from login response
      this.customerProfile = { ...customerProfile }
    },
    data() {
      return {
        customerProfile: {},
        accountObject: {},
        items: [],
        currentItem: {},
        currentItemIndex: null,
        dialogEntityShow: false,
        resolve: null,
        reject: null,
      }
    }, 
    computed: {
      ...mapGetters({
        tooltipDelay: 'users/getTooltipDelay'
      })
    },
    methods: {
      saveEntity (entityData) {
        // update the selected Entity into wconfig object
        this.items[this.currentItemIndex] = JSON.parse(JSON.stringify(entityData));

        const itemsArr = []

        Object.entries(this.items).forEach(([key, value]) => {
          itemsArr.push(value)
        });

        const saveEntityData = {
          strict: true,
          value: {
            op: "WCONFIGUPDATE",
            id: this.customerProfile.id,
            accountId: this.customerProfile.accountId,
            configId: this.accountObject.configId,
            data: {
              wconfig:{
                entities: itemsArr
              }
            }
          }
        }

        // close the Dialog entity
        this.dialogEntityShow = false;

        customerOps.customerUpdateWconfig(saveEntityData)
        .then(response => {
          this.configItems = response.value.data.crmConfig;
          //TODO modify store and sessionStorage to keep update data until refresh,after refresh
          let storageData  = JSON.parse(sessionStorage.getItem('user'));
          storageData.value.data.crmConfig =  response.value.data.crmConfig;
          sessionStorage.setItem("user", JSON.stringify(storageData));

          // commit SET_USER_CONFIGITEMS keep updated data without refresh
          this.$store.commit('users/SET_USER_CONFIGITEMS',response.value.data.crmConfig);

          this.closeDialogEntity(true, false)
        })
        .catch(err => {
          console.error(`[ZendeskWidgetConfig] - saveEntity - error: `, err)

          this.$emit('entity-dialog-close', false, true)
          this.closeDialogEntity(false, true)
        })
      },
      entityToggleChange (changedItem, changedItemIndex) {
        this.$refs.entityButton[changedItemIndex].disabled = changedItem.disable;
        Object.assign(this.items[changedItemIndex], changedItem)
        const itemsArr = []

        Object.entries(this.items).forEach(([key, value]) => {
          itemsArr.push(value)
        });

        const saveEntityData = {
          strict: true,
          value: {
            op: "WCONFIGUPDATE",
            id: this.customerProfile.id,
            accountId: this.customerProfile.accountId,
            configId: this.accountObject.configId,
            data: {
              wconfig:{
                entities: itemsArr
              }
            }
          }
        }

        customerOps.customerUpdateWconfig(saveEntityData)
        .then(response => {
          const successMessage = i18n.t('customer.widgetSettings.toggleUpdateSuccess', {action: `${(changedItem.disable) ? i18n.t('disabled') : i18n.t('enabled')}`, entityLabel: changedItem.entityLabel})
          this.showSnack(successMessage, false);

          this.configItems = response.value.data.crmConfig;
          
          // TODO modify store and sessionStorage to keep update data until refresh,after refresh
          let storageData  = JSON.parse(sessionStorage.getItem('user'));
          storageData.value.data.crmConfig =  response.value.data.crmConfig;
          sessionStorage.setItem("user", JSON.stringify(storageData));

          // commit SET_USER_ACCOUNTS keep updated data without refresh
          this.$store.commit('users/SET_USER_CONFIGITEMS',response.value.data.crmConfig);
        })
        .catch(err => {
          console.error(`[ZendeskWidgetConfig] - entityToggleChange - Entity status update error: `, err)

          // Snackbar error
          this.showSnack(i18n.t('customer.widgetSettings.toggleUpdateError'), true);
        });
      },
      openDialogEntity(data, index) {
        this.currentItem = JSON.parse(JSON.stringify(data))
        this.currentItemIndex = parseInt(index, 10);
        this.dialogEntityShow = true;

        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })

      },
      closeDialogEntity(isSaved, isError) {
        // when return success from save entity
        if (isSaved) {
          this.resolve(true)

          this.dialogEntityShow = false;

          // reset the currentItem and the currentItemIndex
          this.currentItem = {}
          this.currentItemIndex = null
          
          // Snackbar success
          this.showSnack(i18n.t('customer.widgetSettings.wconfigUpdateSuccess'), false);
        }
        // when return error from save entity
        else if (isError) {
          this.resolve(true)

          this.dialogEntityShow = false

          // reset the currentItem and the currentItemIndex
          this.currentItem = {}
          this.currentItemIndex = null

          // Snackbar error
          this.showSnack(i18n.t('customer.widgetSettings.wconfigUpdateError'), true);
        }
        // when the entity dialog was closed without changes
        else {
          this.resolve(false)

          this.dialogEntityShow = false
          this.currentItem = {};
        }
      },
    },
    filters: {
      toCapitalCase: (value) => {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .tooltip-top-right {
    opacity: 0.5;
    position:absolute;
    top:0;
    right:0;
  }
</style>